webpackJsonp(["login"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/login/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bind = bind;

var _login = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/login/login.js");

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bind() {
    return new _login2.default();
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/login/login.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/lottieAnimation/index.js");

var lottie = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Login = function () {
    function Login() {
        _classCallCheck(this, Login);

        this.username = "";
        this.password = "";
        this.signInClicked = false;
        this.registerClicked = false;
        this.forgotPasswordClicked = false;
        this.termsAndConditionsClicked = false;
        this.focusID = "";

        this.init();

        this.watch();
    }

    _createClass(Login, [{
        key: "init",
        value: function init() {

            var loadingAnimationContainer = document.getElementById('loadingAnimationContainer');
            if (loadingAnimationContainer) {
                var loadingAnimation = loadingAnimationContainer.children[0];
                if (loadingAnimation) {
                    lottie.applyToElement(loadingAnimation);
                }
            }

            var focusElementID = document.getElementById('focusElementID');
            if (focusElementID.value) {
                this.focusID = focusElementID.value;
                var focusOn = document.getElementById(this.focusID);
                if (focusOn) {
                    focusOn.focus();
                }
            }
            var triggerSignIn = document.getElementById('triggerSignIn');
            if (triggerSignIn.value == "true") {
                this.signInClicked = true;
            }
            var triggerRegister = document.getElementById('triggerRegister');
            if (triggerRegister.value == "true") {
                this.registerClicked = true;
            }
            var triggerForgotPassword = document.getElementById('triggerForgotPassword');
            if (triggerForgotPassword.value == "true") {
                this.forgotPasswordClicked = true;
            }

            this.getStartImage();
        }
    }, {
        key: "watch",
        value: function watch() {

            var self = this;

            var btnSignIn = document.getElementById('btnSignIn');
            btnSignIn.addEventListener('click', self.updateSignInValue.bind(self));
            btnSignIn.addEventListener('keydown', self.signInKeydown.bind(self));
            btnSignIn.addEventListener('focus', self.focusChanged.bind(self));

            var btnRegister = document.getElementById('btnRegister');
            btnRegister.addEventListener('click', self.updateRegisterClicked.bind(self));
            btnRegister.addEventListener('keydown', self.registerKeydown.bind(self));
            btnRegister.addEventListener('focus', self.focusChanged.bind(self));

            var lnkForgotPassword = document.getElementById('forgotPassword');
            lnkForgotPassword.addEventListener('click', self.updateforgotPasswordClicked.bind(self));
            lnkForgotPassword.addEventListener('keydown', self.forgotPasswordKeydown.bind(self));
            lnkForgotPassword.addEventListener('focus', self.focusChanged.bind(self));

            var lnkTermsAndConditions = document.getElementById('linkTermsAndConditions');
            lnkTermsAndConditions.addEventListener('click', self.updateTermsAndConditionsClicked.bind(self));
            lnkTermsAndConditions.addEventListener('keydown', self.termsAndConditionsKeydown.bind(self));
            lnkTermsAndConditions.addEventListener('focus', self.focusChanged.bind(self));

            var usernameInput = document.getElementById('username');
            this.username = usernameInput.value;
            usernameInput.addEventListener('input', self.updateUsernameValue.bind(self));
            usernameInput.addEventListener('focus', self.focusChanged.bind(self));

            var passwordInput = document.getElementById('password');
            this.password = passwordInput.value;
            passwordInput.addEventListener('input', self.updatePasswordValue.bind(self));
            passwordInput.addEventListener('focus', self.focusChanged.bind(self));
        }
    }, {
        key: "getStartImage",
        value: function getStartImage() {

            var hour = new Date().getHours();
            var image = document.getElementById('image');
            image.classList.add(this.getTimePeriod(hour));
        }
    }, {
        key: "getTimePeriod",
        value: function getTimePeriod(hour) {

            var period = void 0;

            if (hour < 12) {
                period = "morning";
            } else if (hour < 17) {
                period = "afternoon";
            } else {
                period = "evening";
            }
            return period;
        }
    }, {
        key: "updateUsernameValue",
        value: function updateUsernameValue(e) {
            this.username = e.target.value;
        }
    }, {
        key: "updatePasswordValue",
        value: function updatePasswordValue(e) {
            this.password = e.target.value;
        }
    }, {
        key: "focusChanged",
        value: function focusChanged() {
            this.focusID = document.activeElement.id;
        }
    }, {
        key: "showLoadingAnimation",
        value: function showLoadingAnimation() {
            var loadingAnimationContainer = document.getElementById('loadingAnimationContainer');
            if (loadingAnimationContainer) {
                loadingAnimationContainer.style.display = "block";
            }
            var formActionsDiv = document.getElementById('formActionsDiv');
            if (formActionsDiv) {
                formActionsDiv.classList.add("hideDiv");
            }
        }
    }, {
        key: "hideLoadingAnimation",
        value: function hideLoadingAnimation() {
            var loadingAnimationContainer = document.getElementById('loadingAnimationContainer');
            if (loadingAnimationContainer) {
                loadingAnimationContainer.style.display = "none";
            }
            var formActionsDiv = document.getElementById('formActionsDiv');
            if (formActionsDiv) {
                formActionsDiv.classList.remove("hideDiv");
            }
        }
    }, {
        key: "updateSignInValue",
        value: function updateSignInValue() {
            this.signInClicked = true;
            this.showLoadingAnimation();
        }
    }, {
        key: "updateRegisterClicked",
        value: function updateRegisterClicked() {
            this.registerClicked = true;
            this.showLoadingAnimation();
        }
    }, {
        key: "updateforgotPasswordClicked",
        value: function updateforgotPasswordClicked() {
            this.forgotPasswordClicked = true;
            this.showLoadingAnimation();
        }
    }, {
        key: "updateTermsAndConditionsClicked",
        value: function updateTermsAndConditionsClicked() {
            this.termsAndConditionsClicked = true;
            this.showLoadingAnimation();
        }
    }, {
        key: "signInKeydown",
        value: function signInKeydown(e) {
            if (e.code == 'Enter' || e.code == 'NumpadEnter') {
                this.updateSignInValue();
            }
        }
    }, {
        key: "registerKeydown",
        value: function registerKeydown(e) {
            if (e.code == 'Enter' || e.code == 'NumpadEnter') {
                this.updateRegisterClicked();
            }
        }
    }, {
        key: "forgotPasswordKeydown",
        value: function forgotPasswordKeydown(e) {
            if (e.code == 'Enter' || e.code == 'NumpadEnter') {
                this.updateforgotPasswordClicked();
            }
        }
    }, {
        key: "termsAndConditionsKeydown",
        value: function termsAndConditionsKeydown(e) {
            if (e.code == 'Enter' || e.code == 'NumpadEnter') {
                this.updateTermsAndConditionsClicked();
            }
        }
    }, {
        key: "setUsername",
        value: function setUsername(username) {
            DotNet.invokeMethod('MobileHealthFund.Web', 'SetUsername', username);
        }
    }, {
        key: "setPassword",
        value: function setPassword(password) {
            DotNet.invokeMethod('MobileHealthFund.Web', 'SetPassword', password);
        }
    }, {
        key: "signIn",
        value: function signIn() {
            DotNet.invokeMethod('MobileHealthFund.Web', 'SignIn');
        }
    }, {
        key: "register",
        value: function register() {
            DotNet.invokeMethod('MobileHealthFund.Web', 'Register');
        }
    }, {
        key: "forgotPassword",
        value: function forgotPassword() {
            DotNet.invokeMethod('MobileHealthFund.Web', 'ForgotPassword');
        }
    }, {
        key: "termsAndConditions",
        value: function termsAndConditions() {
            DotNet.invokeMethod('MobileHealthFund.Web', 'TermsAndConditions');
        }
    }]);

    return Login;
}();

Login.prototype.toggleAnimation = function (show) {
    if (show) {
        this.showLoadingAnimation();
    } else {
        this.hideLoadingAnimation();
    }
};

Login.prototype.onBlazorStart = function () {
    var usernameInput = document.getElementById('username');
    if (usernameInput) {
        this.setUsername(this.username);
        this.setPassword(this.password);

        // preserve focus, or set to username
        if (this.focusID) {
            var focusOn = document.getElementById(focusID);
            if (focusOn) {
                focusOn.focus();
            }
        } else {
            usernameInput.focus();
        }

        if (this.signInClicked) {
            // var signInButton = document.getElementById('btnSignIn');
            // signInButton.click();
            signIn();
        }
        if (this.registerClicked) {
            register();
        }
        if (this.forgotPasswordClicked) {
            forgotPassword();
        }
        if (this.termsAndConditionsClicked) {
            termsAndConditions();
        }
    }
};

exports.default = Login;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/lottieAnimation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applyToElements = applyToElements;
exports.applyToElement = applyToElement;

var _lottieAnimation = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/lottieAnimation/lottieAnimation.js");

var _lottieAnimation2 = _interopRequireDefault(_lottieAnimation);

var _extractOptions = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utility/extractOptions.js");

var _extractOptions2 = _interopRequireDefault(_extractOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function applyToElements() {

    var lottieElements = document.querySelectorAll("[data-lottie]");
    console.log("Finding Lottie Animations ", lottieElements);
    var lottieElementsArray = Array.prototype.slice.call(lottieElements);

    lottieElementsArray.forEach(applyToElement);
}

function applyToElement(element) {

    var options = Object.assign({}, _lottieAnimation2.default.DEFAULTS, (0, _extractOptions2.default)("lottie", element));
    var instance = new _lottieAnimation2.default(element, options);
    element.instance = instance;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/lottieAnimation/lottieAnimation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lottie = __webpack_require__("external \"lottie\"");

var _lottie2 = _interopRequireDefault(_lottie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LottieAnimation = function () {
    function LottieAnimation(element, options) {
        _classCallCheck(this, LottieAnimation);

        this.element = element;

        if (options.path) {
            this.path = options.path;
        } else {
            this.path = "animations/" + options.name + ".json";
        }

        this.renderer = options.renderer;
        this.autoplay = options.autoplay;
        this.name = options.name;
        this.loop = options.loop;
        this.delay = options.delay;

        this.init();
    }

    _createClass(LottieAnimation, [{
        key: "init",
        value: function init() {

            var self = this;

            _lottie2.default.loadAnimation({
                container: self.element,
                renderer: self.renderer,
                loop: self.loop,
                autoplay: false, //always false, use delay logic
                name: self.name,
                path: self.path
            });

            if (this.autoplay) {
                setTimeout(this.play, this.delay);
            }
        }
    }, {
        key: "play",
        value: function play() {
            _lottie2.default.play(this.name);
        }
    }]);

    return LottieAnimation;
}();

LottieAnimation.DEFAULTS = {
    loop: false,
    autoplay: true,
    renderer: "svg"
};

exports.default = LottieAnimation;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/login.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/login/index.js");

var login = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var inst = login.bind();
var TokenExpires = localStorage.getItem("TokenExpires");
var epochNowSeconds = new Date().getTime() / 1000;

inst.toggleAnimation(!(epochNowSeconds > TokenExpires));

window.login = inst;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utility/extractOptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (name, element) {
	return extractComponentOptions(name, getOptionData(element));
};

/*
 * Unlike other utility files, this is not adding functions to the utility scope
 * This is instead included by some components
 */

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

function camelCase(string) {
	return string.replace(/^([A-Z])|[\s-_](\w)/g, function (match, p1, p2) {
		if (p2) {
			return p2.toUpperCase();
		}

		return p1.toLowerCase();
	});
}

function getOptionData(element) {
	var dataset = element.dataset;
	var data = {};

	for (var prop in dataset) {
		if (dataset.hasOwnProperty(prop)) {
			data[prop] = dataset[prop];
		}
	}
	return data || {};
}

function extractComponentOptions(name, data) {
	var options = {};
	var cameledName = camelCase(name);
	for (var prop in data) {
		if (prop.startsWith(cameledName) && prop !== cameledName) {
			options[camelCase(prop.slice(cameledName.length))] = getJSONValue(data[prop]);
		}
	}
	return options;
}

/***/ }),

/***/ "external \"lottie\"":
/***/ (function(module, exports) {

module.exports = lottie;

/***/ }),

/***/ "multi /tool/project/client/src/core/login.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--4-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/login.js");


/***/ })

},["multi /tool/project/client/src/core/login.js"]);


// WEBPACK FOOTER //
// scripts/login--f72623f3bba644834a69.js